import { schemaAddLink } from '../../../..//api/defaults/links'
import React from 'react'
import { IDefaultLink, TSchemaAddLink } from '../../../../api/types'
import { elWFull, FormLayout, InputGroup, InputWrapFull } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

interface ILinkFormProps {
  formId: string
  defaultValues?: IDefaultLink
  onSubmit: SubmitHandler<TSchemaAddLink>
}

export const LinkForm: React.FC<ILinkFormProps> = ({ defaultValues, onSubmit, formId }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TSchemaAddLink>({
    defaultValues: {
      formType: 'GeneralTenancyAgreement',
      ...defaultValues,
    },
    resolver: yupResolver(schemaAddLink),
  })

  return (
    <ErrorBoundary>
      <form id={formId} onSubmit={handleSubmit(onSubmit)} className={elWFull}>
        <FormLayout hasMargin>
          <InputWrapFull>
            <InputGroup
              label="Title *"
              placeholder="e.g. Residential Tenancies Authority"
              {...register('title')}
              errorMessage={errors.title?.message}
              maxLength={100}
            />
          </InputWrapFull>
          <InputWrapFull>
            <InputGroup
              label="URL *"
              placeholder="e.g. https://www.rta.qld.gov.au/"
              {...register('url')}
              errorMessage={errors.url?.message}
              maxLength={2048}
            />
          </InputWrapFull>
        </FormLayout>
      </form>
    </ErrorBoundary>
  )
}
